export default "__VITE_ASSET__cbHHr$fJ__"